export function redirect(url: string, newTab: boolean = false) {
    if (newTab) {
        window?.open(url, "_blank")?.focus();
    } else {
        window.location.href = url;
    }
}
/**
 * меняем текущий url без перерендера
 * @param newUrl новый url
 * @param method "replace" | "push"
 * @param state
 */

export function updateUrl(
    newUrl: string,
    method: "replace" | "push" = "replace",
    state: any = null
) {
    if (method === "push") {
        window.history.pushState(state, "", newUrl);
    } else {
        window.history.replaceState(state, "", newUrl);
    }
}

/**
 * Собирает строку query-параметров из объекта (без префикса `?`), пригодную для URL.
 * Ключи с `null` и `undefined` пропускаются. Массивы кодируются повторением одного ключа.
 * @param data плоский объект полей запроса
 * @returns строка вида `a=1&b=2` или пустая строка
 */
export function getSearchStringFromObject(data: object): string {
    const searchParams = new URLSearchParams();

    for (const [key, raw] of Object.entries(data)) {
        if (raw === undefined || raw === null) {
            continue;
        }

        if (Array.isArray(raw)) {
            raw.forEach((item) => {
                if (item === undefined || item === null) {
                    return;
                }
                searchParams.append(key, String(item));
            });
            continue;
        }

        if (raw instanceof Date) {
            searchParams.set(key, raw.toISOString());
            continue;
        }

        if (typeof raw === "object") {
            searchParams.set(key, JSON.stringify(raw));
            continue;
        }

        searchParams.set(key, String(raw));
    }

    return searchParams.toString();
}
